/**
 * DEFAULT CONFIG VALUES FOR ALL APP INSTANCES
 *
 * Default valueTypes only.
 * Do not use this file for development, per-instance config, etc.
 */

export default {};
